const SocialLogo = ({ url, size }) => {
  if (url && url.includes("facebook")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl transition-colors duration-200"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h151v-181h-60v-90h60v-61c0-49.628906 40.371094-90 90-90h91v90h-91v61h91l-15 90h-76v181h121c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm0 0"></path>
        </svg>
      </a>
    );
  } else if (url && url.includes("twitter")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl  transition-colors duration-200"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1684 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"></path>
        </svg>
      </a>
    );
  } else if (url && url.includes("github")) {
    return (
      <a target="_blank" rel="noreferrer" href={url}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 1792 1792"
        >
          <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5q0 251-146.5 451.5t-378.5 277.5q-27 5-40-7t-13-30q0-3 .5-76.5t.5-134.5q0-97-52-142 57-6 102.5-18t94-39 81-66.5 53-105 20.5-150.5q0-119-79-206 37-91-8-204-28-9-81 11t-92 44l-38 24q-93-26-192-26t-192 26q-16-11-42.5-27t-83.5-38.5-85-13.5q-45 113-8 204-79 87-79 206 0 85 20.5 150t52.5 105 80.5 67 94 39 102.5 18q-39 36-49 103-21 10-45 15t-57 5-65.5-21.5-55.5-62.5q-19-32-48.5-52t-49.5-24l-20-3q-21 0-29 4.5t-5 11.5 9 14 13 12l7 5q22 10 43.5 38t31.5 51l10 23q13 38 44 61.5t67 30 69.5 7 55.5-3.5l23-4q0 38 .5 88.5t.5 54.5q0 18-13 30t-40 7q-232-77-378.5-277.5t-146.5-451.5q0-209 103-385.5t279.5-279.5 385.5-103zm-477 1103q3-7-7-12-10-3-13 2-3 7 7 12 9 6 13-2zm31 34q7-5-2-16-10-9-16-3-7 5 2 16 10 10 16 3zm30 45q9-7 0-19-8-13-17-6-9 5 0 18t17 7zm42 42q8-8-4-19-12-12-20-3-9 8 4 19 12 12 20 3zm57 25q3-11-13-16-15-4-19 7t13 15q15 6 19-6zm63 5q0-13-17-11-16 0-16 11 0 13 17 11 16 0 16-11zm58-10q-2-11-18-9-16 3-14 15t18 8 14-14z"></path>
        </svg>
      </a>
    );
  } else if (url && url.includes("aedin")) {
    return (
      <a target="_blank" rel="noreferrer" href={url}>
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl text-gray-400 hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M477 625v991h-330v-991h330zm21-306q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zm1166 729v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"></path>
        </svg>
      </a>
    );
  } else if (url && url.includes("instagram")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          viewBox="0 0 64 64"
          role="img"
        >
          <path
            data-name="layer2"
            d="M44.122 2H19.87A17.875 17.875 0 0 0 2 19.835v24.2a17.875 17.875 0 0 0 17.87 17.834h24.252A17.875 17.875 0 0 0 62 44.034v-24.2A17.875 17.875 0 0 0 44.122 2zM55.96 44.034a11.825 11.825 0 0 1-11.838 11.812H19.87A11.825 11.825 0 0 1 8.032 44.034v-24.2A11.825 11.825 0 0 1 19.87 8.022h24.252A11.825 11.825 0 0 1 55.96 19.835zm0 0"
            fill="currentColor"
            stroke="#202020"
            strokeLinecap="round"
            strokeMiterlimit="5"
            strokeWidth="1"
            strokeLinejoin="round"
          ></path>
          <path
            data-name="layer1"
            d="M32 16.45a15.484 15.484 0 1 0 15.514 15.484A15.519 15.519 0 0 0 32 16.45zm0 24.95a9.461 9.461 0 1 1 9.482-9.461A9.472 9.472 0 0 1 32 41.4zm19.263-24.834a3.719 3.719 0 1 1-3.719-3.711 3.714 3.714 0 0 1 3.719 3.711zm0 0"
            fill="currentColor"
            stroke="#202020"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1"
            strokeLinejoin="round"
          ></path>
        </svg>
      </a>
    );
  } else if (url && url.includes("freelancer.com")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
        title="freelancer.com"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl text-gray-400 hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 2500 1855"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m1467.8 0 169.9 238.2L2497.2 0M574.8 1855l464.9-454.6-279.8-300.3M1397.4 0l-248.5 224.1 418 15.6M431.4 0l89.2 182.9 491.9 30.6m-317.8 735 363.4-677.9-1055.3-57M737 991.5l343.3 368.7L1459 989l117.5-691.3-461.5-23.5" />
        </svg>
      </a>
    );
  } else if (url && url.includes("khamsat")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
        title="khamsat.com"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl text-gray-400 hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 104.4 140.7"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50.7 134.8c17.9-.5 31.7-7.2 40.4-22.2 9.1-15.6 9.1-31.6-1-46.8-9-13.6-22.4-19.9-39.1-20.1v20.9c.3.2.5.3.6.3 16.4.8 24.1 12 24.5 23.1.5 11.9-8 20.3-22.6 23.2-1.1.2-2.7 1.9-2.7 3-.2 5.9-.1 11.9-.1 18.6zM6.6 69.7c4.8-9.6 11.3-17.2 20.1-23.1 1.2-.8 1.9-2.9 2-4.5.3-4.7.1-9.5.1-14.7h15.4V6H6.6v63.7zm38-23.1C20 50.3 5.9 77 9.1 90.9h20.5c.9-9.6 4.7-17.3 13.5-21.9.8-.4 1.3-1.9 1.3-2.8.2-6.4.2-12.9.2-19.6zm47.1-19.2V5.9H51.1v21.5h40.6zM44.3 113h-20c-.7 0-1.8.4-2.1.9-4.1 6.6-8.1 13.4-12.4 20.4h34.5V113z"
            style={{
              fill: "#fff",
            }}
          />
          <path d="M50.7 134.8c0-6.7-.1-12.6.1-18.5 0-1.1 1.6-2.8 2.7-3 14.5-2.9 23-11.2 22.6-23.2C75.7 78.9 68 67.7 51.7 67c-.1 0-.3-.1-.6-.3V45.8c16.7.1 30.1 6.5 39.1 20.1 10 15.1 10 31.2 1 46.8-8.8 14.8-22.6 21.6-40.5 22.1zM6.6 69.7V6h37.6v21.4H28.8c0 5.2.2 10-.1 14.7-.1 1.6-.8 3.7-2 4.5C18 52.5 11.4 60.1 6.6 69.7zM44.6 46.6c0 6.7.1 13.1-.1 19.6 0 1-.6 2.4-1.3 2.8-8.8 4.6-12.6 12.3-13.5 21.9H9.2C5.9 77 20 50.3 44.6 46.6zM91.7 27.4H51.1V5.9h40.6v21.5zM44.3 113v21.3H9.8c4.2-7 8.3-13.7 12.4-20.4.3-.5 1.4-.9 2.1-.9h20z" />
        </svg>
      </a>
    );
  } else if (url && url.includes("mostaql")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
        title="mostaql.com"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl text-gray-400 hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 17.7C124.4 17.7 17.7 124.4 17.7 256S124.4 494.3 256 494.3 494.3 387.6 494.3 256 387.6 17.7 256 17.7zm0 382.5c-79.7 0-144.2-64.6-144.2-144.2S176.3 111.8 256 111.8 400.2 176.3 400.2 256 335.7 400.2 256 400.2z" />
        </svg>
      </a>
    );
  } else if (url && url.includes("upwork.com")) {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={url}
        className="p-2 rounded-full text-gray-400 hover:text-gray-200"
        title="upwork.com"
      >
        <svg
          width={size}
          height={size}
          fill="currentColor"
          className="text-xl text-gray-400 hover:text-gray-200 transition-colors duration-200"
          viewBox="0 0 56.7 56.7"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M42.4 17.7c-5.3 0-9.3 3.5-10.9 9-2.5-3.9-4.5-8.3-5.6-12.1h-5.6v14.7c0 2.9-2.4 5.3-5.3 5.3s-5.3-2.4-5.3-5.3V14.7H4.3v14.7c0 6.1 4.9 11 10.9 11s10.9-4.9 10.9-11v-2.5c1.1 2.2 2.5 4.6 4 6.7l-3.5 16.3h5.7L34.7 38c2.2 1.4 4.7 2.2 7.7 2.2 6.1 0 11.1-5 11.1-11.4 0-6.1-5-11.1-11.1-11.1zm0 16.9c-2.2 0-4.5-1-6.3-2.5l.6-2.2v-.1c.4-2.4 1.7-6.4 5.8-6.4 3.1 0 5.6 2.5 5.6 5.6-.1 3.1-2.8 5.6-5.7 5.6z" />
        </svg>
      </a>
    );
  }
  return "";
};

SocialLogo.defaultProps = {};

export default SocialLogo;
